const isPro = process.env.NODE_ENV === 'production';

module.exports = {
	application:'report',
	isPro: isPro,
	imgUrl: isPro?'/Api':'/Api',
	httpTimeoutArr: [
		
	]
}